<template lang="pug">
.question-edit
  app-header.header

  //- パンくずリスト
  ul.breadcrumb
    li
      router-link(to="/") {{ $t('Home') }}
    li
      router-link(to="/master") {{ $t('Master Manage')}}
    li
      router-link(to="/question") {{ $t('Master Service Questions List') }}
    li.active
      span {{ $t('Master Service Questions Edit') }}

  //- タイトル
  h2(style="text-align: center;") {{ $t('Master Service Questions Edit') }}

  form.form-horizontal
    .row.margin-top
      label.col-sm-2.control-label タイトル
      .col-sm-10
        input.form-control(type="text", v-model="title", v-bind:class="{required: !validation.title }")
        p.validation-msg(v-show="!validation.title") {{ $t('validations.required') }}
    template(v-for="(question, index) in questions")
      .row.margin-top
        .col-sm-12.text-center
          h3 評価項目 {{index + 1}}
      .row.margin-top
        label.col-sm-3.control-label カテゴリー
        .col-sm-9
          .sort-card__select-wrap
            select.form-control(v-model="question.serviceCategoryId")
              option(v-for="category in categories" v-bind:value="category.id") {{ category.name }}
          p.validation-msg(v-show="!validation.serviceCategoryId[index]") {{ $t('validations.required') }}
      .row.margin-top
        label.col-sm-3.control-label 確認して欲しいシーン
        .col-sm-9
          textarea.form-control(row="3", v-model="question.scene", placeholder="確認して欲しいシーンを入力してください", v-bind:class="{required: !validation.scene[index] }")
          p.validation-msg(v-show="!validation.scene[index]") {{ $t('validations.required') }}
      .row.margin-top
        label.col-sm-3.control-label 評価内容
        .col-sm-9
          textarea.form-control(row="3", v-model="question.content", placeholder="評価内容を入力してください", v-bind:class="{required: !validation.content[index] }")
          p.validation-msg(v-show="!validation.content[index]") {{ $t('validations.required') }}
      .row.margin-top
        label.col-sm-3.control-label 評価点数（満点）
        .col-sm-3
          .sort-card__select-wrap
            select.form-control(v-model="question.maxPoint")
              option(v-for="point in points" v-bind:value="point") {{ point }}
      .row.margin-top
        .col-sm-12.text-right
          a.btn.btn-default(style="margin-right: 5px;", v-on:click="addContent(index)")
            i.fa.fa-plus-square
            span 追加
          a.btn.btn-danger(v-on:click="deleteContent(index)", v-bind:class="{disabled: questions.length == 1}")
            i.fa.fa-minus-sq
            span 削除

    .row.margin-top
      .col-sm-12.text-right
        a.btn.btn-info(style="margin-right: 5px;", v-on:click="onClickSave()", v-bind:class="{disabled: !validation.not_input}")
          i.fa.fa-floppy-o
          span {{ $t('Save') }}
        a.btn.btn-danger(v-on:click="onClickCancel()")
          i.fa.fa-close
          span {{ $t('Cancel') }}

</template>
<script>
import AppHeader from './AppHeader'

export default {
  name: 'master-service-question-edit',
  created () {
    const loadData = async() => {
      await this.getServiceQuestionCategories()
      await this.search()
    }
    loadData()
  },
  data () {
    return {
      title: '',
      questions: [
        {serviceCategoryId: null, scene: '', content: '', displayOrder: 1, maxPoint: 5}
      ],
      canValidate: true,
      isSearchEnd: false,
      savingFlag: false,
      points: [3, 4, 5]
    }
  },
  computed: {
    categories () {
      let results = [{id: null, name: 'カテゴリーを選択'}]
      return results.concat(this.$store.getters.serviceQuestionCategories)
    },
    validation: function () {
      var v = {
        title: !!this.title,

        not_input: !!this.title
      }

      v.serviceCategoryId = []
      v.serviceCategoryIdAll = true
      for (let index in this.questions) {
        let vc = !!(this.questions[index].serviceCategoryId)
        v.serviceCategoryId.push(vc)
        v.serviceCategoryIdAll &= vc
      }
      v.not_input = v.not_input && !!v.serviceCategoryId.length && !!v.serviceCategoryIdAll

      v.scene = []
      v.sceneAll = true
      for (let index in this.questions) {
        let vc = !!(this.questions[index].scene)
        v.scene.push(vc)
        v.sceneAll &= vc
      }
      v.not_input = v.not_input && !!v.scene.length && !!v.sceneAll

      v.content = []
      v.content_all = true
      for (let index in this.questions) {
        let vc = !!(this.questions[index].content)
        v.content.push(vc)
        v.content_all &= vc
      }
      v.not_input = v.not_input && !!v.content.length && !!v.content_all

      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true })
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getServiceQuestionCategories () {
      await this.$store.dispatch('GET_SERVICE_QUESTION_CATEGORY_ALL', {})
      .catch(err => {
        console.log(err)
        return
      })
    },
    search: function () {
      this.$store.dispatch('GET_MASTER_SERVICE_QUESTION_DETAIL', { id: this.$route.params.id })
      .then(res => {
        console.log(res)
        this.title = res.title
        this.questions = res.question_details.data.map((data, index) => {
          return {
            serviceCategoryId: data.attributes['service-question-category-id'],
            scene: data.attributes['question-scene'],
            content: data.attributes['question-content'],
            displayOrder: index + 1,
            maxPoint: data.attributes['max-point']
          }
        })
        this.isSearchEnd = true
      })
      .catch(err => console.log(err))
    },
    onClickSave: function () {
      if (this.savingFlag) return false
      this.savingFlag = true
      this.questions = this.questions.map((question, index) => {
        question.displayOrder = index + 1
        return question
      })
      this.$store.dispatch('MASTER_SERVICE_QUESTION_UPDATE', {
        id: this.$route.params.id,
        data: {
          title: this.title,
          contents: this.questions
        }
      })
      .then(res => {
        this.$router.push('/master/service_questions')
      })
      .catch(err => console.log(err))
    },
    onClickCancel: function () {
      this.$router.push('/master/service_questions')
    },
    addContent: function (index) {
      let question = {content: null, displayOrder: index + 2}
      this.questions.splice(index + 1, 0, question)
    },
    deleteContent: function (index) {
      this.questions.splice(index, 1)
    }
  }
}

</script>



// WEBPACK FOOTER //
// MasterServiceQuestionEdit.vue?56763439